import React, { useState, useEffect } from 'react';
import './TodoCard.css';
import { Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ServerAddress } from '../../constants/ServerAddress';
import { useSelector } from 'react-redux';
import { FaCalendarAlt, FaCheck, FaClock, FaMinusCircle, FaPlusCircle } from 'react-icons/fa';

const TodoCard = () => {
  const [tasks, setTasks] = useState([]);
  console.log("task-------->",tasks)
  const [filter, setFilter] = useState('all');
  const [newTask, setNewTask] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState('');
  const [loading, setLoading] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalFilter, setModalFilter] = useState('all');
  const [showTasks, setShowTasks] = useState(true);

  const user = useSelector((state) => state.authentication.userdetails);
  const accessToken = useSelector((state) => state.authentication.access_token);

  // Fetch tasks on component mount
  useEffect(() => {
    fetchTasks();
  }, []);

  const fetchTasks = () => {
    setLoading(true);
    axios.get(ServerAddress + `ems/get-todo/?user_id=${user.id}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      }
    })
    .then(response => {
      setTasks(response.data);
      setLoading(false);
    })
    .catch(error => {
      console.error('Error fetching tasks:', error);
      toast.error('Failed to load tasks', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      setLoading(false);
    });
  };

  const statusCounts = {
    all: tasks.length,
    pending: tasks.filter(task => task.status === 'pending').length,
    completed: tasks.filter(task => task.status === 'completed').length
  };

  const addTask = (e) => {
    e.preventDefault();
    if (!newTask.trim()) return;

    setShowLoader(true);
    axios.post(
      ServerAddress + 'ems/add-todo/',
      {
        description: newTask,
        status: 'pending',
        user: user.id,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        }
      }
    )
    .then(response => {
      setTasks([...tasks, response.data]);
      setNewTask('');
      setShowLoader(false);
      toast.success('Task added successfully', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    })
    .catch(error => {
      console.error('Error adding task:', error);
      setShowLoader(false);
      toast.error('Failed to add task', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    });
  };

  const toggleStatus = (id, currentStatus) => {
    const newStatus = currentStatus === 'pending' ? 'completed' : 'pending';
    
    axios.post(
      ServerAddress + `ems/update-todo/${id}/`,
      { status: newStatus },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        }
      }
    )
    .then(() => {
      setTasks(tasks.map(task => 
        task.id === id ? { ...task, status: newStatus } : task
      ));
    })
    .catch(error => {
      console.error('Error updating task status:', error);
      toast.error('Failed to update task status', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    });
  };

  const deleteTask = (id) => {
    axios.post(
      ServerAddress + 'ems/delete-todo/',
      { id },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        }
      }
    )
    .then(() => {
      setTasks(tasks.filter(task => task.id !== id));
      toast.success('Task deleted successfully', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    })
    .catch(error => {
      console.error('Error deleting task:', error);
      toast.error('Failed to delete task', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    });
  };

  const startEditing = (task) => {
    setEditingId(task.id);
    setEditText(task.description);
  };

  const saveEdit = (id) => {
    axios.post(
      ServerAddress + `ems/update-todo/${id}/`,
      { description: editText },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        }
      }
    )
    .then(() => {
      setTasks(tasks.map(task => 
        task.id === id ? { ...task, description: editText } : task
      ));
      setEditingId(null);
      toast.success('Task updated successfully', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    })
    .catch(error => {
      console.error('Error updating task:', error);
      toast.error('Failed to update task', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    });
  };

  const getLast10DaysTasks = () => {
    const tenDaysAgo = new Date();
    tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
    
    return tasks
      .filter(task => new Date(task.created_at) >= tenDaysAgo)
      .filter(task => filter === 'all' || task.status === filter)
      .filter(task => 
        task?.description?.toLowerCase().includes(searchTerm?.toLowerCase())
      );
  };

  const getAllFilteredTasks = () => {
    return tasks
      .filter(task => modalFilter === 'all' || task.status === modalFilter)
      .filter(task => 
        task.description?.toLowerCase().includes(searchTerm?.toLowerCase())
      );
  };

  const groupByDate = (taskList) => {
    return taskList.reduce((acc, task) => {
      const dateObj = new Date(task.created_at);
      const day = String(dateObj.getDate()).padStart(2, '0');
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const year = dateObj.getFullYear();
      const formattedDate = `${day}-${month}-${year}`;
  
      acc[formattedDate] = acc[formattedDate] || [];
      acc[formattedDate].push(task);
      return acc;
    }, {});
  };

  const renderTasks = (taskList) => {
    const grouped = groupByDate(taskList);
    return Object.entries(grouped).map(([date, dateTasks]) => (
      <div key={date}>
        <div className="date-header">{date}</div>
        {dateTasks.map(task => (
          <div key={task.id} className={`task-item ${task.status}`}>
            <div className="task-content">
              <label className="checkbox-container">
                <input
                  type="checkbox"
                  checked={task.status === 'completed'}
                  onChange={() => toggleStatus(task.id, task.status)}
                />
                <span className="checkmark"></span>
              </label>
              {editingId === task.id ? (
                <input
                  type="text"
                  value={editText}
                  onChange={(e) => setEditText(e.target.value)}
                  onBlur={() => saveEdit(task.id)}
                  onKeyPress={(e) => e.key === 'Enter' && saveEdit(task.id)}
                  autoFocus
                />
              ) : (
                <span className="ms-2" >{task.description}</span>
              )}
            </div>
            <div className="task-actions">
              <button onClick={() => startEditing(task)}>Edit</button>
              <button onClick={() => deleteTask(task.id)}>Delete</button>
            </div>
          </div>
        ))}
      </div>
    ));
  };

  if (loading) return <div className="loading">Loading tasks...</div>;

  const last10DaysTasks = getLast10DaysTasks();
  const allTasks = getAllFilteredTasks();

  return (
    <Col lg={12} md={12} sm={12}>
      <div className="todo-card">
        {showLoader && <div className="loader-overlay">Loading...</div>}
        <div className="filter-buttons" style={{ backgroundColor: '#004085', color: '#fff', padding: '5px 8px' }}>
  <button
    className={filter === 'all' ? 'active' : ''}
    onClick={() => setFilter('all')}
    style={{ 
      padding: '4px 8px', 
      fontSize: '12px', 
      display: 'flex', 
      alignItems: 'center', 
      gap: '4px',
      borderRadius: '12px',
      border: '1px solid #e0e0e0',
      background: filter === 'all' ? '#25D366' : '#f0f0f0'
    }}
    title="Last 10 tasks"
  >
    <FaCalendarAlt size={12} />
    <span>Last days 10</span>
  </button>

  <button
    className={filter === 'pending' ? 'active' : ''}
    onClick={() => setFilter('pending')}
    style={{ 
      padding: '4px 8px', 
      fontSize: '12px', 
      display: 'flex', 
      alignItems: 'center', 
      gap: '4px',
      borderRadius: '12px',
      border: '1px solid #e0e0e0',
      background: filter === 'pending' ? '#25D366' : '#f0f0f0'
    }}
    title="Pending tasks"
  >
    <FaClock size={12} />
    <span>{statusCounts.pending}</span>
  </button>

  <button
    className={filter === 'completed' ? 'active' : ''}
    onClick={() => setFilter('completed')}
    style={{ 
      padding: '4px 8px', 
      fontSize: '12px', 
      display: 'flex', 
      alignItems: 'center', 
      gap: '4px',
      borderRadius: '12px',
      border: '1px solid #e0e0e0',
      background: filter === 'completed' ? '#25D366' : '#f0f0f0'
    }}
    title="Completed tasks"
  >
    <FaCheck size={12} />
    <span>{statusCounts.completed}</span>
  </button>

  {tasks.length > last10DaysTasks.length && (
    <button 
      onClick={() => setModalOpen(true)} 
      style={{ 
        marginLeft: 'auto',
        padding: '4px 8px',
        fontSize: '12px',
        borderRadius: '12px',
        border: '1px solid #e0e0e0',
        background: '#f0f0f0'
      }}
    >
      View All
    </button>
  )}
  <button
                  onClick={() => setShowTasks(prev => !prev)}
                  style={{
                    backgroundColor: '#fff',
                    color: '#004085',
                    border: 'none',
                    padding: '3px 5px',
                    borderRadius: '100%',
                    fontSize: '16px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 0 5px rgba(0,0,0,0.2)'
                  }}
                >
                  {showTasks ? <FaMinusCircle /> : <FaPlusCircle />}
                </button>
</div>
{showTasks && (
  <>
    <div className="todo-header">
          <form onSubmit={addTask} className="add-task-form">
            <input
              type="text"
              value={newTask}
              onChange={(e) => setNewTask(e.target.value)}
              placeholder="Add new task..."
            />
            <button type="submit">+</button>
          </form>
    
        </div>

        <div className="todo-list">
          {last10DaysTasks.length === 0 ? (
            <div className="no-tasks">No tasks found</div>
          ) : (
            renderTasks(last10DaysTasks)
          )}
        </div>

  </>
)}
      
        {/* {tasks.length > last10DaysTasks.length && (
          <div className="view-all">
            <button onClick={() => setModalOpen(true)}>
              View All Tasks
            </button>
          </div>
        )} */}

        <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} className="task-modal">
          <ModalHeader toggle={() => setModalOpen(false)} >All Tasks</ModalHeader>
          <ModalBody>
            <div className="modal-filters">
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search tasks..."
                className="modal-search"
              />
              <div className="filter-buttons">
                <button 
                  className={modalFilter === 'all' ? 'active' : ''} 
                  onClick={() => setModalFilter('all')}
                >
                  All
                </button>
                <button 
                  className={modalFilter === 'pending' ? 'active' : ''} 
                  onClick={() => setModalFilter('pending')}
                >
                  Pending
                </button>
                <button 
                  className={modalFilter === 'completed' ? 'active' : ''} 
                  onClick={() => setModalFilter('completed')}
                >
                  Completed
                </button>
              </div>
            </div>
            <div className="modal-tasks-container">
              {allTasks.length === 0 ? (
                <div className="no-tasks">No tasks found</div>
              ) : (
                renderTasks(allTasks)
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <button onClick={() => setModalOpen(false)}>Close</button>
          </ModalFooter>
        </Modal>
      </div>
    </Col>
  );
};

export default TodoCard;